var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-dialog',_vm._b({},'van-dialog',_vm.options,false),[_c('div',[_c('van-field',{attrs:{"placeholder":_vm.placeholder || _vm.$x.t(209742, '请输入')},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }